// Mirrors backend App\Enums\FeeType

export type FeeType = 'fixed' | 'percentage'

export const FeeType = {
  FIXED: 'fixed',
  PERCENTAGE: 'percentage'
} satisfies Record<string, FeeType>

export const FeeTypeValues: readonly FeeType[] = Object.values(FeeType)
